// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"179":"30ef15b6","427":"0ed6922d","594":"374fa547"}[chunkId] + ".js";
};